export default "__VITE_ASSET__2jl3LT3V__"